
import { Component, Prop, Vue } from 'vue-property-decorator';
import stores from '@/stores';
import axiosInstance from '@/helpers/axios';
import AttachImage from '@/modules/Media/Attach.vue';
import { translate } from "../../helpers/functions";
import NevronColorPicker from "@/components/NevronColorPicker.vue";

interface InitialSettings {
  radius: number;
  bgColor: string;
  neutralColor: string;
  primaryColor: string;
  logo: string | null;
  imageId: string | null;
  bgImageId: string | null;
  backGroundImage: string | null;
  focusColor: string;
  gradiantStartColor: string;
  gradiantEndColor: string;
  imageUrl: string;
  isGradiant: boolean;
  buttonTextColor: string | null;
  selectionColor: string | null;
  alertColor: string | null;
  reminderColor: string | null;
  topGradiant: string | null;
  bottomGradiant: string | null;
  floatMenuColor: string | null;
  isImageOnDashboard: boolean;
  bgColorTransparency: string,
}


@Component({
  methods: { translate },
  components: {
    AttachImage,
    NevronColorPicker,
  },
})
export default class DashboardSettings extends Vue {

  @Prop()
  settings!: any;

  @Prop()
  dashboardType!: string;

  defaultDashboardSetting: any = {
    radius: '10',
    bgColor: '',
    neutralColor: '',
    primaryColor: '',
    logo: null,
    imageId: null,
    bgImageId: null,
    backGroundImage: null,
    gradiantStartColor: null,
    gradiantEndColor: null,
    imageUrl: '',
    isGradiant: false,
    buttonTextColor: null,
    selectionColor: null,
    alertColor: null,
    reminderColor: null,
    topGradiant: null,
    bottomGradiant: null,
    floatMenuColor: null,
    isImageOnDashboard: false,
    focusColor: '#ff0000',
    bgColorTransparency: '100',
  };
  attachableContent: any = null;
  contentUrl: any = '';
  type: string = '';

  buttonWidth: any = 511;

  InitialSettings: InitialSettings = {
    bgColor: '#000000',
    neutralColor: '#000000',
    primaryColor: '#000000',
    focusColor: '#000000',
    gradiantStartColor: '#2098FF',
    gradiantEndColor: '#0D209D',
    buttonTextColor: null,
    selectionColor: null,
    alertColor: null,
    reminderColor: null,
    topGradiant: null,
    bottomGradiant: null,
    floatMenuColor: null,
    radius: 10,
    logo: null,
    imageId: null,
    bgImageId: null,
    backGroundImage: null,
    imageUrl: '',
    isGradiant: false,
    isImageOnDashboard: false,
    bgColorTransparency: '100'
  };


  mounted() {
    this.defaultDashboardSetting = this.settings;
    this.type = this.dashboardType;
    // set value max 50 % if mistakenly greater
    if (this.defaultDashboardSetting.radius > 50) {
      this.defaultDashboardSetting.radius = 50;
    }
  }

  radiusControl() {
    const list = document.getElementsByClassName('b-radius');
    for (const i in list) {
      // @ts-ignore
      if (i && list[i] && list[i].style) {
        // @ts-ignore
        list[i].style.borderRadius = this.defaultDashboardSetting.radius + '%';
      }
    }
  }

  sendReload(files: any, result: any) {
    this.defaultDashboardSetting.imageUrl = result.imageUrl;
    this.getImage(result.id);
  }

  getImage(id: number) {
    return stores.File.getImage(id)
      .then((response) => {
        this.defaultDashboardSetting.imageUrl = response.imageUrl;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  attachWithImage(res: any) {
    this.defaultDashboardSetting.imageUrl = res.result.imageUrl;
    this.defaultDashboardSetting.bgImageId = res.result.id;
    this.emitDashboard();
    // @ts-ignore
    this.$refs.image.$children[0].close();
    if (this.defaultDashboardSetting.imageUrl === '' || this.defaultDashboardSetting.imageUrl === null) {
      this.buttonWidth = `margin-top: ${511}px;`;
    } else {
      this.buttonWidth = `margin-top: ${860}px;`;
    }
    this.getImage(res.result.id);
  }

  getHeaders() {
    return stores.File.getHeader();
  }

  getImages() {
    return stores.Folder.getFolder(1)
      .then((response) => {
        this.attachableContent = response;
        this.attachableContent.children = this.attachableContent.folders.concat(
          this.attachableContent.files,
        );
        // @ts-ignore
        this.$refs.image.$children[0].open();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getFilePath(): string {
    return axiosInstance.defaults.baseURL + '/' + stores.File.uploadUrl();
  }

  removeBackGroundImage() {
    this.defaultDashboardSetting.imageUrl = null;
    this.defaultDashboardSetting.bgImageId = null;
    this.emitDashboard();
  }

  emitDashboard() {
    this.$emit('dashboardSetting', this.defaultDashboardSetting);
  }

  updateColor(payload: { color: string; variable: string }) {
    if (this.defaultDashboardSetting.hasOwnProperty(payload.variable)) {
      // @ts-ignore
      this.$set(this.defaultDashboardSetting, payload.variable, payload.color);
      this.emitDashboard();
    } else {
      console.error(`Variable ${payload.variable} does not exist.`);
    }
  }

  setInitialValue(valueToBeChanged: keyof InitialSettings) {
    if (this.InitialSettings.hasOwnProperty(valueToBeChanged)) {
      this.defaultDashboardSetting[valueToBeChanged] = this.InitialSettings[valueToBeChanged];

      if (valueToBeChanged == 'isGradiant') {
        this.defaultDashboardSetting['gradiantStartColor'] = this.InitialSettings['gradiantStartColor'];
        this.defaultDashboardSetting['gradiantEndColor'] = this.InitialSettings['gradiantEndColor'];
      }

      if (valueToBeChanged == 'imageUrl') {
        this.defaultDashboardSetting['isImageOnDashboard'] = this.InitialSettings['isImageOnDashboard'];
      }

      if (valueToBeChanged == 'topGradiant') {
        this.defaultDashboardSetting['bottomGradiant'] = this.InitialSettings['bottomGradiant'];
      }

      this.emitDashboard(); // Emit the updated dashboard setting
    } else {
      console.error(`Property "${valueToBeChanged}" does not exist on initialColorSettings`);
    }
  }

}
